import { AppStore } from "@/store";
import { toastModule } from "@/modules/toast";

export const autoOrganizeNotes = async ({
  noteIds,
  store,
}: {
  noteIds: string[];
  store: AppStore;
}) => {
  const foundNoteIds: string[] = [];
  const notFoundNoteIds: string[] = [];

  for (const noteId of noteIds) {
    const note = await store.notes.getAsync(noteId);
    if (note) {
      foundNoteIds.push(noteId);
    } else {
      notFoundNoteIds.push(noteId);
    }
  }

  if (notFoundNoteIds.length > 0) {
    toastModule.triggerToast({
      content: <div>Failed to fetch {notFoundNoteIds.length} notes. Proceeding with the rest.</div>,
    });
  }

  // create a new session
  const sessionId = await store.sessions.createSession({
    title: `Auto Organize ${foundNoteIds.length} notes`,
    status: "PROCESSING",
    kind: "AUTO_ORGANIZE",
  });

  await store.sessionEvents.createSessionEvent({
    session_id: sessionId,
    event_kind: "EXPERIMENTAL",
    event_value: {
      kind: "auto_organize_v2_input_attached",
      note_ids: foundNoteIds,
    },
  });

  await store.sessionEvents.createMessageSentSessionEvent({
    session_id: sessionId,
    message_value: {
      kind: "REASONING",
      content: `Analyzing ${foundNoteIds.length} notes`,
    },
  });

  toastModule.triggerToast({
    content: <div>Auto organizing {foundNoteIds.length} notes.</div>,
  });
};
